import { BaseDto } from "../base.dto";
import { FileDto } from "../file.dto";
import { PagingDto } from "../paging.dto";
import { TranslationDto } from "../translation.dto";

export class OfflineTenantVoucherDto extends BaseDto {
  id: string;
  status?: boolean;
  approvalStatus?: number;
  pinned?: boolean;
  isRunning?: boolean;
  validFrom?: string;
  validTo?: string;
  displayStart?: string;
  displayEnd?: string;
  numberOfCode?: number;
  userLimit?: number;
  assignedCount?: number;
  usedCount?: number;
  expiredCount?: number;
  applyType?: number;
  applyValue?: number;
  applyMaxValue?: number;
  minExpense?: number;
  sendNoti?: number;
  notiContentEn?: string;
  notiContentKh?: string;
  notiTemplateId?: string;
  notiSchedule?: string;
  title?: TranslationDto;
  description?: TranslationDto;
  terms?: TranslationDto;
  bannerImage?: {
    en?: FileDto;
    kh?: FileDto;
  };
  bannerImageId?: {
    en?: string;
    kh?: string;
  };
  mall?: {
    id: string;
    name: TranslationDto;
  };
  offlineTenants?: {
    id: string;
    name: TranslationDto;
  }[];
  codeSource?: number;
  uploadId?: string;
}

export class OfflineTenantVoucherMappingDto extends BaseDto {
  id?: string;
  mallId?: string;
  offlineTenantIds?: string[];
  status?: boolean;
  pinned?: boolean;
  isRunning?: boolean;

  validFrom?: string; // ISO Date string
  validTo?: string;
  displayStart?: string;
  displayEnd?: string;

  numberOfCode?: number;
  userLimit?: number;
  assignedCount?: number;

  applyType?: number;
  applyValue?: number;
  applyMaxValue?: number;
  minExpense?: number;

  sendNoti?: number;
  notiContentEn?: string;
  notiContentKh?: string;

  notiTemplateId?: string;
  notiSchedule?: string;

  title?: TranslationDto;

  description?: TranslationDto;

  terms?: TranslationDto;

  bannerImage?: {
    en?: FileDto;
    kh?: FileDto;
  };
  bannerImageId?: {
    en?: string;
    kh?: string;
  };
  codeSource?: number;
  uploadId?: string;

  static create({
    id,
    mallId,
    offlineTenantIds,
    status,
    pinned,
    isRunning,
    validFrom,
    validTo,
    displayStart,
    displayEnd,
    numberOfCode,
    userLimit,
    assignedCount,
    applyType,
    applyValue,
    applyMaxValue,
    minExpense,
    sendNoti,
    notiContentEn,
    notiContentKh,
    notiTemplateId,
    notiSchedule,
    title,
    description,
    terms,
    bannerImage,
    bannerImageId,
    codeSource,
    uploadId,
  }: OfflineTenantVoucherMappingDto) {
    const instance = new OfflineTenantVoucherMappingDto();

    // Basic properties with defaults
    Object.assign(instance, {
      id: id ?? null,
      mallId: mallId ?? null,
      offlineTenantIds: offlineTenantIds ?? [],
      status: status ?? true,
      pinned: pinned ?? false,
      isRunning: isRunning ?? false,
    });

    // Date properties
    Object.assign(instance, {
      validFrom: validFrom ?? null,
      validTo: validTo ?? null,
      displayStart: displayStart ?? null,
      displayEnd: displayEnd ?? null,
    });

    // Numeric properties
    Object.assign(instance, {
      numberOfCode: numberOfCode ?? null,
      userLimit: userLimit ?? null,
      assignedCount: assignedCount ?? null,
      applyType: applyType ?? null,
      applyValue: applyValue ?? null,
      applyMaxValue: applyMaxValue ?? null,
      minExpense: minExpense ?? null,
    });

    // Notification properties
    Object.assign(instance, {
      sendNoti: sendNoti ?? null,
      notiContentEn: notiContentEn ?? null,
      notiContentKh: notiContentKh ?? null,
      notiTemplateId: notiTemplateId ?? null,
      notiSchedule: notiSchedule ?? null,
    });

    // Translation properties
    Object.assign(instance, {
      title: title ?? TranslationDto.create(),
      description: description ?? TranslationDto.create(),
      terms: terms ?? TranslationDto.create(),
    });

    // Image properties
    Object.assign(instance, {
      bannerImage: bannerImage ?? { en: null, kh: null },
      bannerImageId: bannerImageId ?? { en: null, kh: null },
    });

    // Additional properties
    Object.assign(instance, {
      codeSource: codeSource ?? null,
      uploadId: uploadId ?? null,
    });

    return instance;
  }
}

export class CreateOfflineTenantVoucherDto extends OfflineTenantVoucherMappingDto {}

export class UpdateOfflineTenantVoucherDto extends OfflineTenantVoucherDto {}

export enum OfflineTenantVoucherCodeStatus {
  USED = "USED",
  NOT_SAVED = "NOT_SAVED",
  SAVED_NOT_USED = "SAVED_NOT_USED",
}
export class OfflineTenantVoucherCodeDto extends BaseDto {
  code?: string;
  uploadedTime?: Date;
  customerId?: string;
  customerName?: string;
  email?: string;
  phoneNumber?: string;
  allocatedTime?: Date;
  usedAt?: Date;
  status?: OfflineTenantVoucherCodeStatus;
  tenantName?: string;
  discount?: string;
  transactionAmount?: number;
}

export class FindOfflineTenantVoucherDto extends PagingDto {
  search?: string;
  mallId?: string;
  offlineTenantId?: string;
  statusType?: string; // 'running', 'incoming', 'ended'
  onlyDeleted?: boolean;
  approvalStatus?: number;
  validFrom?: string;
  validTo?: string;
  voucherType?: number;
}

export class FindOfflineTenantVoucherListOfCodesDto extends PagingDto {
  status?: string;
}

export class NotificationTemplateDto {
  id: string;
  contentEn: string;
  contentKh: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export class OfflineTenantVoucherStatsDto {
  all: number;
  approved: number;
  rejected: number;
  running: number;
  incoming: number;
  ended: number;
  deleted: number;
}
